
document.addEventListener('DOMContentLoaded', function () {
  const shopBtn = document.querySelector('.nav-shop-toggle'); // bottom nav "Shop"
  const drawer = document.getElementById('Details-menu-drawer-container'); // menu drawer <details>
  const navItems = document.querySelectorAll('.nav-item'); // all nav items

  // --- Helper: clear all active states ---
  function clearActive() {
    navItems.forEach(item => item.classList.remove('active'));
  }

  // --- Detect current page and mark active ---
  const currentPath = window.location.pathname.replace(/\/+$/, ''); // normalize
  const currentURL = window.location.href;

  navItems.forEach(item => {
    const href = item.getAttribute('href');
    if (!href) return;
    const normalizedHref = href.replace(window.location.origin, '').replace(/\/+$/, '');
    const isSearch = normalizedHref.includes('/search');

    // Match logic
    if ((currentPath === '' || currentPath === '/') && normalizedHref === '/') {
      clearActive(); item.classList.add('active');
    } else if (isSearch && currentPath.includes('/search')) {
      clearActive(); item.classList.add('active');
    } else if (currentPath === normalizedHref || currentPath.startsWith(normalizedHref)) {
      clearActive(); item.classList.add('active');
    }
  });

  // --- Handle Shop Drawer Toggle ---
  if (shopBtn && drawer) {
    shopBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = drawer.hasAttribute('open');

      // Clear other actives before setting
      clearActive();

      if (isOpen) {
        // Close drawer
        drawer.removeAttribute('open');
        drawer.classList.remove('menu-opening');
        document.body.classList.remove('menu-opening');
        document.documentElement.classList.remove('menu-opening');
        shopBtn.classList.remove('active');
      } else {
        // Open drawer
        drawer.setAttribute('open', 'open');
        drawer.classList.add('menu-opening');
        document.body.classList.add('menu-opening');
        document.documentElement.classList.add('menu-opening');
        shopBtn.classList.add('active');

        // Accessibility: focus first menu item
        const firstLink = drawer.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (firstLink) firstLink.focus({ preventScroll: true });
      }
    });
  }

  // --- Handle Nav Clicks ---
  navItems.forEach(item => {
    item.addEventListener('click', function () {
      clearActive();
      this.classList.add('active');
    });
  });
});

